import { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type StepFormInputProps = InputHTMLAttributes<HTMLInputElement> & PropsWithClassName;

const StepFormInput = forwardRef<HTMLInputElement, StepFormInputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'border border-[rgba(0,0,0,0.12)] bg-white rounded-xl px-4 py-3.5 font-dm text-sm text-black',
      'placeholder:text-[rgba(0,0,0,0.38)] outline-none focus:border-[rgba(0,0,0,0.3)] w-full',
      className
    )}
    {...props}
  />
));

StepFormInput.displayName = 'StepFormInput';

export default StepFormInput;
